/**
 * 取引ステータス
 */
export type DealStatus =
| "1" // 下書き
| "2" // 審査中
| "3" // 承諾待ち
| "4" // レビュー中
| "5"; // 完了

/** 取引ステータス：下書き */
export const Draft = "1" as DealStatus;
/** 取引ステータス：審査中 */
export const UnderReview = "2" as DealStatus;
/** 取引ステータス：承諾待ち */
export const AgreementPending= "3" as DealStatus;
/** 取引ステータス：レビュー中 */
export const InReview = "4" as DealStatus;
/** 取引ステータス：完了 */
export const Completed = "5" as DealStatus;